import React from 'react';
import { ChevronLeft, Info, History, ArrowDownCircle } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { v2, formatDate } from '../constants';

export default function WalletView() {
  const { lang, t, userData, withdrawals, withdrawAmount, setWithdrawAmount, handleWithdraw, uploading, setView } = useAppContext();

  const statusColor = (s) => {
    if (s === 'COMPLETED' || s === 'PAID') return { color: v2.colors.green, bg: v2.colors.softGreen };
    if (s === 'REJECTED') return { color: v2.colors.red, bg: v2.colors.softRed };
    return { color: '#B45309', bg: '#FFF7E6' };
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F5F7FA', padding: '14px 16px 40px' }}>

      {/* 页头 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        <button onClick={() => setView('profile')} style={{ width: '38px', height: '38px', borderRadius: '8px', border: `1px solid ${v2.colors.line}`, background: v2.colors.surface, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <ChevronLeft size={22} color={v2.colors.ink} />
        </button>
        <div>
          <p style={{ margin: 0, color: v2.colors.muted, fontSize: '12px', fontWeight: '700' }}>{lang === 'es' ? 'Finanzas' : '财务'}</p>
          <h2 style={{ margin: 0, fontWeight: '900', color: v2.colors.ink, fontSize: '21px' }}>{t.wallet}</h2>
        </div>
      </div>

      {/* 余额卡片 */}
      <div style={{ background: 'linear-gradient(135deg, #1648D8 0%, #2962FF 55%, #1A3FBB 100%)', borderRadius: '20px', padding: '28px 24px', color: '#fff', marginBottom: '16px', boxShadow: '0 8px 28px rgba(41,98,255,0.28)' }}>
        <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '700', opacity: 0.8, letterSpacing: '0.5px' }}>{t.balance}</p>
        <h1 style={{ margin: 0, fontSize: '42px', fontWeight: '900', letterSpacing: '-1px' }}>
          ${(userData?.wallet_balance || 0).toFixed(2)}
        </h1>
        <p style={{ margin: '10px 0 0 0', fontSize: '12px', opacity: 0.7 }}>
          {lang === 'es' ? 'Billetera FixBox · sin comisión de retiro' : 'FixBox 钱包 · 提现零手续费'}
        </p>
      </div>

      {/* 提现卡片 */}
      <div style={{ ...v2.card, padding: '20px', marginBottom: '16px' }}>
        <p style={{ margin: '0 0 12px 0', fontWeight: '900', color: v2.colors.ink, fontSize: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <ArrowDownCircle size={17} color={'#2962FF'} />{t.withdraw}
        </p>

        {/* 金额输入 */}
        <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${withdrawAmount ? '#2962FF' : v2.colors.line}`, borderRadius: '10px', overflow: 'hidden', backgroundColor: v2.colors.surface, transition: 'border-color 0.2s' }}>
          <span style={{ padding: '0 14px', fontSize: '20px', fontWeight: '900', color: v2.colors.muted, borderRight: `1px solid ${v2.colors.line}` }}>$</span>
          <input type="number" value={withdrawAmount} onChange={e => setWithdrawAmount(e.target.value)} placeholder="0.00"
            style={{ flex: 1, height: '54px', padding: '0 14px', border: 'none', outline: 'none', fontSize: '26px', fontWeight: '800', color: v2.colors.ink, backgroundColor: 'transparent' }} />
        </div>

        {/* 提现规则 */}
        <div style={{ backgroundColor: '#FFFBEB', padding: '13px 15px', borderRadius: '10px', marginTop: '14px', border: '1px solid #FEF3C7' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '7px' }}>
            <Info size={14} color="#D97706" />
            <span style={{ fontWeight: '900', color: '#D97706', fontSize: '12px' }}>{lang === 'es' ? 'Reglas de Retiro' : '提现规则'}</span>
          </div>
          <ul style={{ margin: 0, paddingLeft: '18px', color: '#92400E', fontSize: '12px', lineHeight: '1.7', fontWeight: '500' }}>
            <li>{lang === 'es' ? 'Mínimo $20.00, sin comisión (0%).' : '最低提款额 $20.00，无手续费 (0%)。'}</li>
            <li>{lang === 'es' ? 'Límite de 1 solicitud de retiro por día.' : '每天仅限申请 1 次提款。'}</li>
            <li>{lang === 'es' ? 'Pagos por ACH de Lunes a Sábado a las 8:00 PM.' : '通过 ACH 转账，周一至周六晚上 8:00 打款。'}</li>
          </ul>
        </div>

        <button onClick={handleWithdraw} disabled={uploading}
          style={{ width: '100%', padding: '16px', backgroundColor: uploading ? v2.colors.line : '#2962FF', color: '#fff', borderRadius: '10px', border: 'none', marginTop: '16px', fontWeight: '900', fontSize: '16px', cursor: uploading ? 'not-allowed' : 'pointer', boxShadow: uploading ? 'none' : '0 6px 16px rgba(37,99,235,0.3)', transition: 'all 0.2s' }}>
          {uploading ? (lang === 'es' ? 'Procesando...' : '处理中...') : t.withdraw}
        </button>
      </div>

      {/* 资金明细 */}
      <div>
        <p style={{ margin: '0 0 12px 0', fontWeight: '900', color: v2.colors.ink, fontSize: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <History size={17} color={v2.colors.muted} />{t.withdraw_hist}
        </p>
        {withdrawals.length === 0 && (
          <p style={{ textAlign: 'center', color: v2.colors.muted, fontSize: '13px', marginTop: '20px' }}>
            {lang === 'es' ? '— Sin movimientos —' : '— 暂无数据 —'}
          </p>
        )}
        {withdrawals.map(w => {
          const sc = statusColor(w.status);
          return (
            <div key={w.id} style={{ ...v2.card, padding: '14px 16px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <b style={{ fontSize: '17px', color: v2.colors.ink }}>${(Number(w.amount) || 0).toFixed(2)}</b>
                <p style={{ fontSize: '11px', color: v2.colors.muted, margin: '3px 0 0 0' }}>{formatDate(w.createdAt)}</p>
              </div>
              <span style={{ backgroundColor: sc.bg, color: sc.color, fontWeight: '800', fontSize: '11px', padding: '4px 10px', borderRadius: '20px' }}>{w.status}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
